import React from 'react';

/*tslint:disable-next-line:variable-name*/
const EmptyItem = () => (
  <div className="cost-data__row cost-data__aligned-row">
    <div className="cost-data__content-cell cost-data__content-row-number cost-data__content-row-number--hidden-counter" />
    <div className="cost-data__content-cell cost-data__content-name">&nbsp;</div>
    <div className="cost-data__content-cell cost-data__content-amount" />
    <div className="cost-data__content-cell cost-data__content-control" />
  </div>
);

export default EmptyItem;
